import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FolderSidebar = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 4H7L7 11.2L7 12H13.5V4ZM2.5 4H6L6 11.2L6 12H2.5L2.5 4ZM2.5 3C1.94772 3 1.5 3.44772 1.5 4V12C1.5 12.5523 1.94772 13 2.5 13H13.5C14.0523 13 14.5 12.5523 14.5 12V4C14.5 3.44772 14.0523 3 13.5 3H2.5ZM3.5 5C3.22386 5 3 5.22386 3 5.5C3 5.77614 3.22386 6 3.5 6H5C5.27614 6 5.5 5.77614 5.5 5.5C5.5 5.22386 5.27614 5 5 5H3.5ZM3 7.5C3 7.22386 3.22386 7 3.5 7H5C5.27614 7 5.5 7.22386 5.5 7.5C5.5 7.77614 5.27614 8 5 8H3.5C3.22386 8 3 7.77614 3 7.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10H5C5.27614 10 5.5 9.77614 5.5 9.5C5.5 9.22386 5.27614 9 5 9H3.5Z"
        />
      </svg>
    )
  },
)

export default FolderSidebar
